import { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import LoginService from "../../../api/services/login_Service";
import { apiList } from "../../../api/apiList";
import { useNavigate } from "react-router";
import TextInputFloat from "../../common/components/textInput/TextInputFloat";
import logo from "../../../assets/icons/logoNew.png";
import UserIcon from "../../../assets/icons/user.svg";
import { decrypt } from "../../../helpers/encrypt";
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { setLoginData, selectLoginData, setRememberMe } from './login.actions';
import Modal from "../../common/components/modal";
import "./login.css";

const Login = ({ setIsLoading, showToastMessage }) => {
  const dispatch = useDispatch();
  const { rememberMe, credential } = useSelector(selectLoginData);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState('');
  // const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();



  const handleLogin = async (e) => {
    e.preventDefault();
    if (username !== "" && password !== "") {
      try {
        setIsLoading(true);
        const data = await LoginService.login({
          Username: username,
          Password: password,
          ismobile: true,
          appVersion: apiList.appVersion,
        }).json();
        setIsLoading(false);
        if (data.message === "Your account is locked!") {
          openModal('EP SPORTS', 'Your account is locked !');
          navigate("/login");
        } else {
          dispatch(setLoginData({ ...data, rememberMe, username, password }));
          navigate("/rules?loggedIn=true");
        }
        // dispatch(setLoginData({ ...data, rememberMe, username, password }));
        // navigate("/rules?loggedIn=true");
        // localStorage.setItem("token", data.token);
        // localStorage.setItem("userDetails", JSON.stringify(data.userDetails));
        // if (rememberMe) {
        //   const credential = encrypt({ username, password });
        //   // console.log("credential", credential);
        //   localStorage.setItem("rememberMe", "true");
        //   localStorage.setItem("credential", credential);
        // } else {
        //   localStorage.removeItem("rememberMe");
        //   localStorage.removeItem("credential");
        // }

      } catch (error) {
        // Show an error toast on login failure
        setIsLoading(false);
        // setIsModalOpen(true);
        openModal('EP SPORTS', `Login Fail !`);
      }
    }
  };

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRememberMeChange = (e) => {
    dispatch(setRememberMe());
  }

  useEffect(() => {
    // const isRememberMe = localStorage.getItem("rememberMe");
    // console.log(isRememberMe);
    // console.log(isRememberMe == "true");
    // const credential = localStorage.getItem("credential");
    if (rememberMe && credential) {
      const decrypted = decrypt(credential);
      // console.log(decrypted);
      setUsername(decrypted?.username || '');
      setPassword(decrypted?.password || '');
    }
    //eslint-disable-next-line
    // setRememberMe(isRememberMe == "true");
  }, [credential, rememberMe]);


  return (
    <div className="relative flex items-center justify-center w-full min-h-[100dvh] p-4 overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(125deg,#A50D21_50%,#E7082A_50%)]"></div>
      <div className="absolute top-16 -right-20 w-64 h-12 bg-ep_White/20 rounded-full rotate-[125deg]"></div>
      <div className="absolute top-2 -right-4 w-48 h-12 bg-ep_White/20 rounded-full rotate-[125deg]"></div>
      <div className="absolute -bottom-2 right-10 w-32 h-12 bg-ep_White/20 rounded-full rotate-[125deg]"></div>
      <div className="absolute top-20 left-10 h-24 w-14 text-white/60 bg-dot-pattern [background-size:12px_12px]" />
      <div className="absolute bottom-96 right-8 h-14 w-32 text-white/60 bg-dot-pattern [background-size:12px_12px]" />
      <div className="relative z-10 w-full max-w-md">
          {/* Logo Section */}
          <div className="mb-4 text-center transition-transform duration-300 transform hover:scale-105">
            <div className="inline-block">
              <div className="flex flex-col items-center" data-aos="fade-up">
                <img src={logo} alt="logo" className="h-32 duration-300 mb-2 drop-shadow-lg" />
                <h1 className="text-xl font-bold font-inter text-ep_White leading-tight drop-shadow-sm">
                  EP SPORTS
                </h1>
                <div className="flex items-center space-x-4 mt-1.5">
                  <div className="h-px w-8 bg-ep_White"></div>
                  <p className="text-xs text-ep_White font-bold uppercase tracking-widest">Welcome Back</p>
                  <div className="h-px w-8 bg-ep_White"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Login Card */}
          <div className="overflow-hidden">
            {/* Card Header */}
            <div className="relative px-6 ">
              {/* <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-ep_Gold via-ep_Yellow to-ep_Yellow"></div> */}
              {/* <h1 className="text-xl font-bold text-center text-white"></h1> */}
              <p className="mt-1 text-sm text-center text-white/90">Sign in to continue</p>
              {/* Luxury Border Accent */}
            </div>

            {/* Card Content */}
            <div className="p-6">
              {/* User Avatar */}
              {/* <div className="flex justify-center mb-6">
                <div className="flex items-center justify-center w-20 h-20 transition-all duration-300 transform border-2 shadow-lg bg-gradient-to-br from-ep_Red via-ep_DeepRed to-ep_Red rounded-xl border-ep_Gold/40 hover:scale-110">
                  <img src={UserIcon} alt="User Icon" className="w-8 h-8 filter brightness-0 invert" />
                </div>
              </div> */}

              {/* Login Form */}
              <form onSubmit={handleLogin} className="space-y-4 px-10">
                <div className="space-y-4">
                  <TextInputFloat
                    id={"username"}
                    placeholder={"Username"}
                    value={username}
                    type="text"
                    setValue={setUsername}
                  />
                  <TextInputFloat
                    id={"password"}
                    placeholder={"Password"}
                    value={password}
                    type="password"
                    setValue={setPassword}
                  />
                </div>

                {/* Remember Me */}
                <div className="flex items-center">
                  <input
                    id="remember-checkbox"
                    type="checkbox"
                    checked={rememberMe}
                    onChange={handleRememberMeChange}
                    className="w-4 h-4 transition-all duration-200 bg-white border-2 rounded cursor-pointer text-ep_Red border-ep_Red/30 focus:ring-ep_Red focus:ring-2"
                  />
                  <label
                    htmlFor="remember-checkbox"
                    className="ml-2 text-sm font-semibold cursor-pointer select-none text-ep_White"
                  >
                    Remember Me
                  </label>
                </div>

                {/* Login Button */}
                <button
                  type="submit"
                  className="w-full bg-ep_Gold hover:shadow-xl text-white font-bold py-3 px-6 rounded-xl shadow-lg transition-all duration-300 border-2 border-ep_Gold/40 transform hover:scale-[1.02]"
                >
                  <span className="text-base tracking-wide">SIGN IN</span>
                </button>
              </form>

              {/* Security Badge */}
              <div className="mt-5 text-center">
                <div className="inline-flex items-center px-3 py-1.5 bg-ep_White/10 rounded-lg border border-ep_Red/20">
                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2 animate-pulse"></div>
                  <span className="text-xs font-medium text-ep_White">Secured Connection</span>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-14 mb-4 text-center">
            <p className="text-sm font-semibold text-ep_White">
              EP Sports Platform
            </p>
            <div className="flex flex-wrap items-center justify-center gap-1 mt-3 space-x-4">
              <div className="flex items-center text-xs text-ep_White/80">
                <div className="w-1.5 h-1.5 bg-ep_White rounded-full mr-1.5"></div>
                Secure Login
              </div>
              <div className="flex items-center text-xs text-ep_White/80">
                <div className="w-1.5 h-1.5 bg-ep_White rounded-full mr-1.5"></div>
                24/7 Support
              </div>
              <div className="flex items-center text-xs text-ep_White/80">
                <div className="w-1.5 h-1.5 bg-ep_White rounded-full mr-1.5"></div>
                Premium Service
              </div>
            </div>
          </div>
      </div>

      {isModalOpen && (
        <Modal title={modalTitle} content={modalContent} onClose={closeModal} />
      )}
    </div>
  );
};

export default Login;
